const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const SensorPeripheral = require('../common/sensor-peripheral');
const { default: bleUtils } = require('../../util/ble');
const { BLE_CONFIG } = require('../../util/bleCharac');

/**
 * YM-K3 按键传感器模块
 * 
 * @readonly
 */
const DEVICE_OPT = {
    type: 'sensor'
};

/**
 * Manage communication with a YM-K3 peripheral over a Scratch Link client socket.
 */
class YM5GPeripheral extends SensorPeripheral {
    constructor(runtime, deviceId, originalDeviceId) {
        super(runtime, deviceId, originalDeviceId, null, BLE_CONFIG, DEVICE_OPT);
         // 添加 MQTT 配置缓存
    this.mqttConfigCache = {
        clientId: 'ym5g_client',
        host: 'localhost',
        port: 1883,
        user: '',
        password: '',
        qos: 0
    };
     // 添加 MQTT 状态缓存
     this.mqttStatusCache = 0;
     // 添加消息缓存
    this.latestMqttMessage = '';
    
    }
       
    }

class ScratchYM5GDevice {

    get DEVICE_ID() {
        return 'YM5G';
    }

    constructor(runtime, originalDeviceId) {
        this.runtime = runtime;
        this._peripheral = new YM5GPeripheral(this.runtime, this.DEVICE_ID, originalDeviceId);
        this.bleUtils = new bleUtils();
        
        // this._setupNotifyHandlers();
        // 添加消息缓存
        this.latestMqttMessage = '';
    
         //  添加：是否正在连接或已连接
         this._connectionLock = false;
         this._connectionPromise = null;
    }

    getInfo() {
        return [{
            id: 'YM5G',
            name: formatMessage({
                id: 'YM5G.categoryName',
                default: 'YM5G',
                description: 'Label for the YM 5G extension category'
            }),
            color1: "#556600",
            color2: "#6DB14D",
            color3: "#64A23C",
            blocks: [
                {
                    opcode: 'connect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YM5G.ble.connect',
                        default: 'connect to YM-5G-[DEVICE_NAME]',
                        description: 'Connect to YM 5G'
                    }),
                    arguments: {
                        DEVICE_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        }
                    }
                },
                {
                    opcode: 'disConnect',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'YM5G.ble.disconnect',
                        default: 'disconnect from YM 5G',
                        description: 'Disconnect from YM 5G'
                    })
                },
                {
                    opcode: 'getSignalStrength',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YM5G.getSignalStrength',
                        default: 'get signal strength',
                        description: 'Get signal strength'
                    })
                },
                {
                    opcode: 'getIMEI',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YM5G.getIMEI',
                        default: 'get IMEI',
                        description: 'Get IMEI'
                    })
                },
                {
                    opcode: 'getOperator',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YM5G.getOperator',
                        default: 'get operator',
                        description: 'Get operator'
                    })
                },
                {
                    opcode: 'getICCID',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YM5G.getICCID',
                        default: 'get ICCID',
                        description: 'Get ICCID'
                    })
                },
                {
                    opcode: 'getSIMId',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YM5G.getSIMId',
                        default: 'get SIM TYPE',
                        description: 'Get SIM TYPE'
                    })
                },
                {
                    opcode: 'get5GStatus',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'YM5G.get5GStatus',
                        default: 'get 5G status',
                        description: 'Get 5G status'
                    })
                },
                '---',
                // MQTT 配置积木
            {
                opcode: 'setMqttClientId',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.setClientId',
                    default: 'set MQTT client ID to [CLIENTID]',
                    description: 'Set MQTT client ID'
                }),
                arguments: {
                    CLIENTID: {
                        type: ArgumentType.STRING,
                        defaultValue: 'ym5g_client'
                    }
                }
            },
            {
                opcode: 'setMqttHost',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.setHost',
                    default: 'set MQTT host to [HOST]',
                    description: 'Set MQTT host'
                }),
                arguments: {
                    HOST: {
                        type: ArgumentType.STRING,
                        defaultValue: 'localhost'
                    }
                }
            },
            {
                opcode: 'setMqttPort',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.setPort',
                    default: 'set MQTT port to [PORT]',
                    description: 'Set MQTT port'
                }),
                arguments: {
                    PORT: {
                        type: ArgumentType.NUMBER,
                        defaultValue: 1883
                    }
                }
            },
            {
                opcode: 'setMqttUser',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.setUser',
                    default: 'set MQTT user to [USER]',
                    description: 'Set MQTT user'
                }),
                arguments: {
                    USER: {
                        type: ArgumentType.STRING,
                        defaultValue: ''
                    }
                }
            },
            {
                opcode: 'setMqttPassword',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.setPassword',
                    default: 'set MQTT password to [PASSWORD]',
                    description: 'Set MQTT password'
                }),
                arguments: {
                    PASSWORD: {
                        type: ArgumentType.STRING,
                        defaultValue: ''
                    }
                }
            },
            {
                opcode: 'setMqttQos',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.setQos',
                    default: 'set MQTT QoS to [QOS]',
                    description: 'Set MQTT QoS'
                }),
                arguments: {
                    QOS: {
                        type: ArgumentType.NUMBER,
                        defaultValue: 0,
                        menu: 'qosLevels'
                    }
                }
            },
            {
                opcode: 'connectMqtt',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.connect',
                    default: 'connect to MQTT broker',
                    description: 'Connect to MQTT broker'
                })
            },
            {
                opcode: 'disconnectMqtt',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.disconnect',
                    default: 'disconnect from MQTT broker',
                    description: 'Disconnect from MQTT broker'
                })
            },
            {
                opcode: 'getMqttStatus',
                blockType: BlockType.REPORTER,
                text: formatMessage({
                    id: 'YM5G.mqtt.getStatus',
                    default: 'MQTT connection status',
                    description: 'Get MQTT connection status'
                })
            },
            {
                opcode: 'getMqttConfig',
                blockType: BlockType.REPORTER,
                text: formatMessage({
                    id: 'YM5G.mqtt.getConfig',
                    default: 'MQTT [CONFIG] value',
                    description: 'Get MQTT configuration value'
                }),
                arguments: {
                    CONFIG: {
                        type: ArgumentType.STRING,
                        menu: 'mqttConfigItems'
                    }
                }
            },
            {
                opcode: 'publishMqttMessage',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.publish',
                    default: 'publish topic [TOPIC] message [MESSAGE]',
                    description: 'Publish MQTT message'
                }),
                arguments: {
                    TOPIC: {
                        type: ArgumentType.STRING,
                        defaultValue: 'topic/test'
                    },
                    MESSAGE: {
                        type: ArgumentType.STRING,
                        defaultValue: 'Hello MQTT'
                    }
                }
            },
            {
                opcode: 'subscribeMqttTopic',
                blockType: BlockType.COMMAND,
                text: formatMessage({
                    id: 'YM5G.mqtt.subscribe',
                    default: 'subscribe to topic [TOPIC]',
                    description: 'Subscribe to MQTT topic'
                }),
                arguments: {
                    TOPIC: {
                        type: ArgumentType.STRING,
                        defaultValue: 'topic/test'
                    }
                }
            },
            {
                opcode: 'getLatestMqttMessage',
                blockType: BlockType.REPORTER,
                text: formatMessage({
                    id: 'YM5G.mqtt.getLatestMessage',
                    default: 'latest MQTT message',
                    description: 'Get latest MQTT message'
                })
            },{
                opcode: 'whenMqttMessageReceived',
                blockType: BlockType.HAT,  // HAT类型积木
                text: formatMessage({
                    id: 'YM5G.mqtt.whenMessageReceived',
                    default: 'when MQTT message received on topic [TOPIC]',
                    description: 'Event triggered when an MQTT message is received on specified topic'
                }),
                arguments: {
                    TOPIC: {
                        type: ArgumentType.STRING,
                        defaultValue: 'topic/test'
                    }
                }
            }
            ],
                
            menus: {
                qosLevels: {
                    items: [
                        { text: '0', value: 0 },
                        { text: '1', value: 1 },
                        { text: '2', value: 2 }
                    ]
                },
                mqttConfigItems: {
                    items: [
                        { text: formatMessage({ id: 'YM5G.mqtt.config.clientId', default: 'client ID', description: 'MQTT client ID' }), value: 'clientId' },
        { text: formatMessage({ id: 'YM5G.mqtt.config.host', default: 'host', description: 'MQTT host' }), value: 'host' },
        { text: formatMessage({ id: 'YM5G.mqtt.config.port', default: 'port', description: 'MQTT port' }), value: 'port' },
        { text: formatMessage({ id: 'YM5G.mqtt.config.user', default: 'user', description: 'MQTT user' }), value: 'user' },
        { text: formatMessage({ id: 'YM5G.mqtt.config.qos', default: 'QoS', description: 'MQTT QoS' }), value: 'qos' }
                    ]
                }
            }
        }];
    }

/**
     * Connect to YM-K3 device
     * @param {object} args - { DEVICE_NAME }
     */
async connect(args) {
    const deviceName = 'YM-5G-' + (args.DEVICE_NAME?.trim() || "");

    // 🔒 如果已经在连接流程中，直接返回已有 promise
    if (this._connectionPromise) {
        console.log(`Connection already in progress or completed. Skipping duplicate connect for ${deviceName}`);
        return await this._connectionPromise;
    }

    // 🔒 创建一个连接 promise 并缓存，防止后续调用再次触发 requestDevice
    this._connectionPromise = this._doConnect(deviceName).catch(err => {
        console.error('Connection failed:', err);
        // 失败后允许重试（可选）：若想禁止重试，则不清理 _connectionPromise
        // this._connectionPromise = null;
    });

    return await this._connectionPromise;
}
 /**
     * 实际执行连接逻辑（仅执行一次）
     */
 async _doConnect(deviceName) {
    // 再次检查是否已连接（避免 race condition）
    const connected = await this.isConnected();
    if (connected) {
        console.log('Already connected. Skip connection.');
        return true;
    }

    console.log(`Connecting to YM 5G device: ${deviceName}`);

    try {
        // ✅ 此处调用 bleUtils.connect，假设它封装了 requestDevice
        await this.bleUtils.connect(deviceName, BLE_CONFIG.SERVICE_UUID);
        console.log(`Connected to device: ${deviceName}`);
        //await this._setupNotifyHandlers();
        return true;
    } catch (error) {
        // 清理状态，允许用户手动重试
        this._connectionPromise = null;
        throw error; // 抛出错误以便上层处理
    }
}
    async isConnected() {
        return this.bleUtils.device !== null && this.bleUtils.device.gatt.connected;
    }

    async disConnect() {
        if (this.bleUtils.device) {
            try {
                await this.bleUtils.disConnect(this.bleUtils.device);
                console.log('Disconnected from device');
                 // 🔒 断开后释放连接锁，允许重新连接
                 this._connectionPromise = null;
            } catch (error) {
                console.error('Failed to disconnect:', error);
            }
        }
    }

    async _setupNotifyHandlers() {
        if (!this.bleUtils.device || !this.bleUtils.device.gatt.connected) return;
        // Key1
        try {
            const charKey = await this.bleUtils.getCharacteristic(this.bleUtils.service, BLE_CONFIG.recvData);
            console.log('Starting notifications for key presses...');
            // Start notifications for key presses
            await this.bleUtils.notifyCharacteristic(charKey, value => {
                //TODO 做显示
            });
        } catch (e) {}
    }

    /**
 * Get signal strength
 */
async getSignalStrength() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.signalStrength
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            // 根据数据长度选择合适的解析方式
            if (dataView.byteLength === 1) {
                return dataView.getUint8(0);
            } else if (dataView.byteLength === 2) {
                return dataView.getUint16(0, true);
            } else {
                // 默认作为字符串处理
                return new TextDecoder().decode(dataView.buffer);
            }
        }
        return 0;
    } catch (error) {
        console.error('Failed to get signal strength:', error);
        return 0;
    }
}

/**
 * Get IMEI
 */
async getIMEI() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return '';
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.IMEI
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            return new TextDecoder().decode(dataView.buffer);
        }
        return '';
    } catch (error) {
        console.error('Failed to get IMEI:', error);
        return '';
    }
}

/**
 * Get operator
 */
async getOperator() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return '';
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.operator
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            return new TextDecoder().decode(dataView.buffer);
        }
        return '';
    } catch (error) {
        console.error('Failed to get operator:', error);
        return '';
    }
}

/**
 * Get ICCID
 */
async getICCID() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return '';
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.iccid
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            return new TextDecoder().decode(dataView.buffer);
        }
        return '';
    } catch (error) {
        console.error('Failed to get ICCID:', error);
        return '';
    }
}

/**
 * Get SIM ID
 */
async getSIMId() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return '';
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.simId
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView.byteLength === 1) {
            return dataView.getUint8(0);
        }
        return 0;
    } catch (error) {
        console.error('Failed to get SIM ID:', error);
        return '';
    }
}

/**
 * Get 5G status
 */
async get5GStatus() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.status5G
        );
        const dataView = await this.bleUtils.readCharacteristic(characteristic);
        
        if (dataView?.buffer instanceof ArrayBuffer) {
            if (dataView.byteLength === 1) {
                return dataView.getUint8(0);
            } else if (dataView.byteLength === 2) {
                return dataView.getUint16(0, true);
            } else {
                return new TextDecoder().decode(dataView.buffer);
            }
        }
        return 0;
    } catch (error) {
        console.error('Failed to get 5G status:', error);
        return 0;
    }
}
/**
 * Set MQTT client ID
 */
async setMqttClientId(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.mqtt_clientId
        );
        const data = new TextEncoder().encode(args.CLIENTID);
        await this.bleUtils.writeCharacteristic(characteristic, data);
        this._peripheral.mqttConfigCache.clientId = args.CLIENTID;
    } catch (error) {
        console.error('Failed to set MQTT client ID:', error);
    }
}

/**
 * Set MQTT host
 */
async setMqttHost(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_host
        );
        const data = new TextEncoder().encode(args.HOST);
        await this.bleUtils.writeCharacteristic(characteristic, data);
        this._peripheral.mqttConfigCache.host = args.HOST;
    } catch (error) {
        console.error('Failed to set MQTT host:', error);
    }
}

/**
 * Set MQTT port
 */
async setMqttPort(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_port
        );
        const portValue = new Uint16Array([Number(args.PORT)]);
        await this.bleUtils.writeUint16Characteristic(characteristic, portValue);
        this._peripheral.mqttConfigCache.port = parseInt(args.PORT);
    } catch (error) {
        console.error('Failed to set MQTT port:', error);
    }
}

/**
 * Set MQTT user
 */
async setMqttUser(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_user
        );
        const data = new TextEncoder().encode(args.USER);
        await this.bleUtils.writeCharacteristic(characteristic, data);
        this._peripheral.mqttConfigCache.user = args.USER;
    } catch (error) {
        console.error('Failed to set MQTT user:', error);
    }
}

/**
 * Set MQTT password
 */
async setMqttPassword(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_pwd
        );
        const data = new TextEncoder().encode(args.PASSWORD);
        await this.bleUtils.writeCharacteristic(characteristic, data);
        this._peripheral.mqttConfigCache.password = args.PASSWORD;
    } catch (error) {
        console.error('Failed to set MQTT password:', error);
    }
}

/**
 * Set MQTT QoS
 */
async setMqttQos(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_qos
        );
        const qosValue = new Uint8Array([parseInt(args.QOS)]);
        await this.bleUtils.writeCharacteristic(characteristic, qosValue);
        this._peripheral.mqttConfigCache.qos = parseInt(args.QOS);
    } catch (error) {
        console.error('Failed to set MQTT QoS:', error);
    }
}

/**
 * Connect to MQTT broker
 */
async connectMqtt() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_connect
        );
        const cmd = new Uint8Array([1]); // 1 表示连接命令
        await this.bleUtils.writeCharacteristic(characteristic, cmd);
    } catch (error) {
        console.error('Failed to connect to MQTT broker:', error);
    }
}
/**
 * Disconnect from MQTT broker
 */
async disconnectMqtt() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_connect
        );
        const cmd = new Uint8Array([0]); // 0 表示断开连接命令
        await this.bleUtils.writeCharacteristic(characteristic, cmd);
        this.mqttStatusCache = false; // 更新本地缓存状态
    } catch (error) {
        console.error('Failed to disconnect from MQTT broker:', error);
    }
}
/**
 * Get MQTT connection status
 */
async getMqttStatus() {
    if (!this.bleUtils.device) {
        return 0;
    }
    
    try {
        const characteristic = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_state
        );
         // 改为读取方式获取状态
         const dataView = await this.bleUtils.readCharacteristic(characteristic);
         if (dataView?.buffer instanceof ArrayBuffer && dataView.byteLength >= 1) {
             this._peripheral.mqttStatusCache = dataView.getUint8(0) ;
         }
        return this._peripheral.mqttStatusCache;
    } catch (error) {
        console.error('Failed to get MQTT status:', error);
        return this.mqttStatusCache;
    }
}

/**
 * Get MQTT configuration value
 */
/**
 * Synchronize MQTT configuration from device
 */
async syncMqttConfig() {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        // 依次获取各项配置并更新缓存
        const clientIdChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_clientId
        );
        const clientIdData = await this.bleUtils.readCharacteristic(clientIdChar);
        if (clientIdData?.buffer instanceof ArrayBuffer) {
            this._peripheral.mqttConfigCache.clientId = new TextDecoder().decode(clientIdData.buffer);
        }
        
        const hostChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_host
        );
        const hostData = await this.bleUtils.readCharacteristic(hostChar);
        if (hostData?.buffer instanceof ArrayBuffer) {
            this._peripheral.mqttConfigCache.host = new TextDecoder().decode(hostData.buffer);
        }
        
        const portChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_port
        );
        const portData = await this.bleUtils.readCharacteristic(portChar);
        if (portData.byteLength >= 2) {
            this._peripheral.mqttConfigCache.port = portData.getUint16(0, true);
        }
        
        const userChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_user
        );
        const userData = await this.bleUtils.readCharacteristic(userChar);
        if (userData?.buffer instanceof ArrayBuffer) {
            this._peripheral.mqttConfigCache.user = new TextDecoder().decode(userData.buffer);
        }
        
        const qosChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service, 
            BLE_CONFIG.mqtt_qos
        );
        const qosData = await this.bleUtils.readCharacteristic(qosChar);
        if (qosData.byteLength >= 1) {
            this._peripheral.mqttConfigCache.qos = qosData.getUint8(0);
        }
        
    } catch (error) {
        console.error('Failed to synchronize MQTT configuration:', error);
    }
}
/**
 * Publish MQTT message
 */
async publishMqttMessage(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        // 发布消息需要先设置主题、消息内容和QoS
        // 设置主题
        const topicChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.mqtt_topic
        );
        const topicData = new TextEncoder().encode(args.TOPIC);
        await this.bleUtils.writeCharacteristic(topicChar, topicData);
        
      
        
    
         // 设置消息内容
         const msgChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.mqtt_publish
        );
        const msgData = new TextEncoder().encode(args.MESSAGE);
        await this.bleUtils.writeCharacteristic(msgChar, msgData);
    } catch (error) {
        console.error('Failed to publish MQTT message:', error);
    }
}

/**
 * Subscribe to MQTT topic
 */
async subscribeMqttTopic(args) {
    if (!this.bleUtils.device) {
        console.warn('Device not connected');
        return;
    }
    
    try {
        // 设置要订阅的主题
        const topicChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.mqtt_topic
        );
        const topicData = new TextEncoder().encode(args.TOPIC);
        await this.bleUtils.writeCharacteristic(topicChar, topicData);
        
       
        // 启用通知来接收订阅的消息
        const messageChar = await this.bleUtils.getCharacteristic(
            this.bleUtils.service,
            BLE_CONFIG.mqtt_subscribe  // 或者应该是接收消息的特征值
        );
        let message = '';
        // 注册通知回调处理接收到的MQTT消息
        await this.bleUtils.notifyCharacteristic(messageChar, (value) => {
            // 处理接收到的MQTT消息
             message = new TextDecoder().decode(value);
            console.log(`Received MQTT message on topic ${args.TOPIC}: ${message}`);
          // 更新最新的消息缓存
          this.latestMqttMessage = message;
          this._peripheral.latestMqttMessage = message;
        });
        
       return message;
    } catch (error) {
        console.error('Failed to subscribe to MQTT topic:', error);
    }
}
/**
 * Get latest MQTT message
 */
getLatestMqttMessage() {
    return this._peripheral.latestMqttMessage || this.latestMqttMessage || '';
}
}

module.exports = ScratchYM5GDevice;
